var map = {
	"./forgot-form.es.js": 122,
	"./login-form.es.js": 123,
	"./verification-form.es.js": 124
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 121;


//////////////////
// WEBPACK FOOTER
// ./components/login-wizard/widget \.js$
// module id = 121
// module chunks = 5